import Rollbar from "rollbar";

export default new Rollbar(window._rollbarConfig);
